export default __webpack_public_path__ + "static/media/30.53bcff58.jpg";